import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import SmoothScroll from "./components/SmoothScroll";
import Portfolio from "./pages/Portfolio";
import CaseStudy from "./pages/CaseStudy";
import AtherCaseStudy from "./pages/AtherCaseStudy";
import AIInsightsHubCaseStudy from "./pages/AIInsightsHubCaseStudy";
import CreatorPerformanceCaseStudy from "./pages/CreatorPerformanceCaseStudy";
import SuprDailyCaseStudy from "./pages/SuprDailyCaseStudy";
import MakerFaireCaseStudy from "./pages/MakerFaireCaseStudy";
import FieldTerritoryInsightsHubCaseStudy from "./pages/FieldTerritoryInsightsHubCaseStudy";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Routes>
              <Route path="/" element={<Portfolio />} />
              <Route path="/projects/ather-energy-design-direction" element={<AtherCaseStudy />} />
              <Route path="/projects/ai-insights-hub" element={<AIInsightsHubCaseStudy />} />
              <Route path="/projects/creator-performance-analytics" element={<CreatorPerformanceCaseStudy />} />
              <Route path="/projects/suprdaily-redesign" element={<SuprDailyCaseStudy />} />
              <Route path="/projects/maker-faire-redesign" element={<MakerFaireCaseStudy />} />
              <Route path="/projects/field-territory-insights-hub" element={<FieldTerritoryInsightsHubCaseStudy />} />
              <Route path="/projects/:slug" element={<CaseStudy />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </SmoothScroll>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
